import { z } from "zod";

export const activityLabelSchema = z.object({
  id: z.string().optional(),
  label: z.string().min(1, { message: "El label debe ser válido" }),
  enabled: z.boolean().default(true),
  zonesIds: z.array(z.string()).optional(),
});
